import { InfoCircleFilled } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import { LegacyPopover } from '@creditornot/cb-popover';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  title: string;
  description: string;
  children: JSX.Element;
};

const Title = styled(T.Body3)``;

const PopoverContent = styled(T.Body3)`
  display: block;
  width: 372px;
  padding: 8px;
`;

const IconContainer = styled.span`
  padding: 0 8px;
  cursor: pointer;
`;

const InfoIcon = styled(InfoCircleFilled)`
  width: 12px;
  height: 12px;
  /* ignore-color */
  fill: ${colors.pepper52};
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  margin-inline-start: auto;
  padding-inline-start: 8px;
`;

const Root = styled.div`
  display: flex;
  align-items: center;
`;

export const VisualSetting = ({ title, description, children }: Props) => (
  <Root>
    <Title>{title}</Title>

    <LegacyPopover
      placement="top"
      renderArrow={false}
      disableContentPadding
      content={<PopoverContent>{description}</PopoverContent>}
    >
      <IconContainer>
        <InfoIcon />
      </IconContainer>
    </LegacyPopover>

    <InputContainer>{children}</InputContainer>
  </Root>
);
